// extracted by mini-css-extract-plugin
export default {"button":"CreateEventButton_button__oqjSi"};